export default "__VITE_PUBLIC_ASSET__b68540c8__"